<template>
  <v-card>
    <v-card-text class="headline text-xs-center secondary--text">
      CPFs permitidos no convênio
      <div v-if="convenio_posto" class="subheading grey--text text--darken-2">{{convenio_posto.convenio.codigo}}</div>
    </v-card-text>
    <v-card-text class="pt-0 scroll-y" style="max-height: 300px">
      <v-list>
        <v-list-tile v-if="!cpf_list.length">
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center title font-weight-light">Sem CPFs adicionados</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <template v-for="(cpf, index) in cpfs_masked" v-else>
          <v-divider :key="`divider-${index}`" v-if="index > 0"></v-divider>
          <v-list-tile :key="index" avatar>
            <v-list-tile-avatar>
              <v-icon color="green">
                person
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-text="cpf"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
                <v-btn icon color="red" dark small @click="removerCPF(index)">
                    <v-icon size="18">
                        close
                    </v-icon>
                </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-text>
    <v-container flex grid-list-md >
      <v-layout align-center>
        <v-flex xs10>
          <v-textarea
            outline
            single-line
            placeholder="Lista dos CPFs permitidos"
            persistent-hint
            hint="Copie de cole a coluna de CPFs do excel para cá, separados por quebra de linha,
              mantendo os CPFs no formato ###.###.###-##."
            :loading="loading"
            v-model="cpfs"
          ></v-textarea>
        </v-flex>
        <v-flex xs2 align-self-center>
          <v-tooltip bottom>
            <v-btn slot="activator" dark icon color="info" :disabled="loading" @click="adicionarCPF()">
              <v-icon>add</v-icon>
            </v-btn>
            Adicionar
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
        <v-btn color="grey darken-2" flat @click="fecharTela()">
            VOLTAR
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" flat @click="atualizarDados()">
            SALVAR
        </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['convenio_posto'],
  data () {
    return {
      cpf_list: [],
      cpfs: null
    }
  },
  mounted () {
    if (this.convenio_posto) {
      this.cpf_list = this.convenio_posto.convenio.cpfs_permitidos
    }
  },
  watch: {
    convenio_posto (val) {
      if (val) {
        this.cpf_list = val.convenio.cpfs_permitidos
      } else {
        this.cpf_list = []
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    cpfs_masked () {
      let tempList = []
      this.cpf_list.forEach(cpf => {
        tempList.push(`${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, 2)}`)
      })
      return tempList
    }
  },
  methods: {
    adicionarCPF () {
      if (this.cpfs) {
        this.cpfs.split('\n').forEach(cpf => {
          if (cpf.length === 14) {
            this.cpf_list.push(this.unmask(cpf, '###.###.###-##'))
          }
        })
        this.cpfs = null
      }
    },
    unmask (value, mask) {
      let tempValue = ''
      mask.split('').forEach((v, index) => {
        if (v === '#' && index < value.length) {
          tempValue += value[index]
        }
      })
      return tempValue
    },
    removerCPF (indice) {
      this.cpf_list.splice(indice, 1)
    },
    fecharTela () {
      this.$emit('fechar')
    },
    atualizarDados () {
      this.$store.dispatch('atualizarConvenio', {
        id: this.convenio_posto.id,
        data: { ...this.convenio_posto, cpfs_permitidos: this.cpf_list }
      }).then(() => {
        this.$store.dispatch('listarConvenios')
        this.fecharTela()
      })
    }
  }
}
</script>
